import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { DataState } from './data.selectors';

import * as actions from '@/store/auction-house/data.actions';

export const initialState: DataState = {
  activeAuction: {
    punkId: '-1',
    owner: null,
    startBlock: 0,
    settled: false,
    events: [],
    bid: null,
    secondsLeft: 0,
    endTime: 0,
    blocksRemaining: 0
  },
  currentBlock: 0
};

export const dataStateReducer: ActionReducer<DataState, Action> = createReducer(
  initialState,
  on(actions.resetDataState, () => initialState),
  on(actions.setActiveAuction, (state, { activeAuction }) => {
    return {
      ...state,
      activeAuction
    };
  }),
  on(actions.setCurrentBlock, (state, { currentBlock }) => {
    return {
      ...state,
      currentBlock
    };
  })
);
